import HtmlUi from './src/js/HtmlUi';

export default HtmlUi;



// WEBPACK FOOTER //
// ./index.js